import { axiosPost } from "../axios/config";

const prefix = "/api/v2/administration/";

export const getDashboards = async (data) => {
	const response = await axiosPost(`${prefix}get-all-dashboards`, data);
	return response;
};
